export default "__VITE_ASSET__Ckv6k_7N__"